<template>
  <BContainer
    class="p-0"
    fluid
  >
    <BRow
      class="py-2"
    >
      <BCol
        cols="12"
      >
        <CustomTable
          ref="tableDocuments"
          table-class="min-h-375px"
          :provider="tableProvider"
          :fields="tableDocuments.fields"
          :filter="tableDocuments.filter"
          :filter-on="tableDocuments.filterOn"
          :sort-by="tableDocuments.sortBy"
          :sort-desc="tableDocuments.sortDesc"
          :sort-direction="tableDocuments.sortDirection"
          :total-rows="tableDocuments.totalRows"
          :current-page="tableDocuments.currentPage"
          :per-page="tableDocuments.perPage"
          :stacked="tableDocuments.stacked"
          :busy="tableDocuments.busy"
        >
          <template #cell(action)="{ item }">
            <div class="text-md-nowrap d-flex flex-column flex-md-row justify-content-center">
              <BButton
                size="sm"
                variant="warning"
                :disabled="tableDocuments.busy"
                @click.prevent="viewDocument(item)"
              >
                View
              </BButton>
            </div>
          </template>
        </CustomTable>
      </BCol>
    </BRow>

    <BModal
      ref="modalDocument"
      scrollable
      centered
      hide-header
      no-close-on-esc
      no-enforce-focus
      no-close-on-backdrop
      modal-class="full-height modal-no-padding"
      aria-hidden="false"
      role="dialog"
    >
      <div class="p-2 min-h-400px max-h-400px">
        <ValidationObserver
          ref="formDocument"
        >
          <form
            role="form"
            novalidate
            @submit.prevent
          >
            <BRow>
              <BCol
                cols="12"
              >
                <BFormGroup
                  label="Document Type"
                  label-for="fDocumentType"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <BFormInput
                    id="fDocumentType"
                    v-model="formDocument.document_type_name"
                    disabled
                  />
                </BFormGroup>
              </BCol>

              <!-- <BCol
                v-if="state.editing"
                cols="12"
              >
                <BFormGroup>
                  <BFormCheckbox
                    id="fActive"
                    v-model="formDocument.active"
                    switch
                    value="1"
                    name="active"
                    unchecked-value="0"
                    disabled
                  >
                    Is Active?
                  </BFormCheckbox>
                </BFormGroup>
              </BCol> -->
            </BRow>
          </form>
        </ValidationObserver>

        <attachment-uploader
          ref="attachmentUploader"
          :path="formDocument.attachment_path"
          :files="formDocument.attachments"
          :busy="state.busy"
          :show-uploader="!state.editing"
          @onUploaded="updateFormDocument"
        />
      </div>
      <template #modal-footer="{ cancel }">
        <BButton

          variant="outline-dark"
          :disabled="state.busy"
          @click.prevent="discardBtnEvent => preventAriaHidden(discardBtnEvent, cancel)"
        >
          Close
        </BButton>
      </template>
    </BModal>
  </BContainer>
</template>

<script>
import AttachmentUploader from '@/views/rsm/customer-management/documents/Uploader.vue'

import MxMisc from '@/mixins/misc'
import MxFormatter from '@/mixins/formatter'
import MProvinces from '@/mixins/locations/provinces'
import MMunicipalities from '@/mixins/locations/municipalities'
import MBarangays from '@/mixins/locations/barangays'
import MDocumentTypes from '@/mixins/maintenances/document-types'

import { SRSMCustomerDocument } from '@/services/rsm'

export default {
  name: 'VRSMCustomerDocuments',

  components: {
    'attachment-uploader': AttachmentUploader
  },

  mixins: [
    MProvinces,
    MMunicipalities,
    MBarangays,
    MDocumentTypes,
    MxFormatter,
    MxMisc
  ],

  props: {
    customer: {
      type: Object,
      required: true,
      default: () => ({
        id: ''
      })
    }
  },

  data () {
    return {
      state: {
        busy: false,
        editing: false
      },
      formDocument: {
        customer_id: this.customer.id,
        document_type_id: '',
        document_type_name: '',
        attachment_path: '',
        attachments: [],
        active: 1
      },
      tableDocuments: {
        busy: false,
        filter: {
          search: '',
          customer: this.customer.id
        },
        filterOn: [],
        stacked: 'sm',
        sortBy: 'id',
        sortDesc: false,
        sortDirection: 'asc',
        pageOptions: [10, 25, 50, 100],
        currentPage: 1,
        totalRows: 0,
        perPage: 10,
        fields: [
          { mobile: 0, key: 'index', label: '#', class: 'text-center' },
          { mobile: 3, key: 'action', class: 'text-center w-md-125px' },
          { mobile: 1, key: 'document_type.document_type_name', label: 'Document Type', class: 'min-w-150px' },
          { mobile: 2, key: 'updated_at', class: 'min-w-175px', formatter: this.dateTimeShortFormatter, sortable: true }
        ].sort(this.scaleOnMobile)
      }
    }
  },

  methods: {

    async tableProvider ({ currentPage, perPage, sortBy, sortDesc, filter }) {
      this.tableDocuments.busy = true
      const payload = {
        page: currentPage,
        per_page: perPage,
        sort: sortBy,
        sort_desc: sortDesc,
        filter_text: filter.search,
        customer_id: filter.customer
      }

      return await SRSMCustomerDocument.get(payload).then(
        ({ data }) => {
          this.tableDocuments.totalRows = data.total_rows
          return data.items
        }
      ).catch(
        () => {
          this.tableDocuments.totalRows = 0
          return []
        }
      ).finally(() => {
        this.tableDocuments.busy = false
      })
    },

    // downloadConsent () {
    //   this.generatePDFCustomerConsent().then(
    //     consentDocument => {
    //       consentDocument.download(`${this.customer.first_name} ${this.customer.last_name} - Consent.pdf`)
    //     }
    //   )
    // },

    viewDocument (customerDocument) {
      this.state.editing = true

      this.formDocument = Object.assign(this.formDocument, {
        id: customerDocument.id,
        customer_id: this.customer.id,
        attachment_path: customerDocument.attachment_path,
        attachments: customerDocument.attachments,
        document_type_id: customerDocument.document_type_id,
        document_type_name: customerDocument.document_type?.document_type_name,
        active: customerDocument.active
      })

      this.$refs.modalDocument.show()
    },

    updateFormDocument (attachment) {
      this.formDocument = Object.assign(this.formDocument, {
        attachment_path: attachment.attachment_path,
        attachments: attachment.attachments
      })
    },

    async validateDocument () {
      await this.$refs.formDocument.validate().then(
        async validDocument => {
          if (!validDocument) {
            return this.swalInvalid()
          }

          this.swalConfirm({
            html: this.state.editing ? '<h6>Update Customer Documents?</h6>' : '<h6>Add Documents to Customer?</h6>',
            confirmButtonText: this.state.editing ? 'Update' : 'Add',
            preConfirm: async () => {
              this.state.busy = true

              const createOrUpdate = async () => {
                return this.putDocument()
              }

              return createOrUpdate().catch(
                ({ message }) => {
                  this.$refs.attachmentUploader.$refs.formDocument.setErrors(message.errors)
                  this.$refs.formDocument.setErrors(message.errors)
                }
              ).finally(() => {
                this.state.busy = false
              })
            }
          })
        }
      )
    },

    async putDocument () {
      return await SRSMCustomerDocument.put(this.formDocument).then(
        ({ data: { message, customer_document: customerDocument } }) => {
          this.$refs.modalDocument.hide()
          this.swalSuccess(message).then(() => {
            this.$refs.tableDocuments.updateRow({
              id: customerDocument.id,
              customer_id: this.customer.id,
              attachment_path: customerDocument.attachment_path,
              attachments: customerDocument.attachments,
              document_type_id: customerDocument.document_type_id,
              active: customerDocument.active,
              updated_at: customerDocument.updated_at
            })
          })
        }
      )
    }
  }
}
</script>
